var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDoctorB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218,
    height: 250,
    viewBox: "0 0 218 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H315V250H0z",
    transform: "translate(-637 -414) translate(552 330) translate(37 84)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#343A40",
    fillRule: "nonzero",
    d: "M156.542 125c34.259 0 62.025-27.979 62.025-62.5S190.8 0 156.542 0c-34.258 0-62.024 27.979-62.024 62.5s27.766 62.5 62.024 62.5zm-58.147 82.031c0 6.494 5.184 11.719 11.63 11.719 6.444 0 11.629-5.225 11.629-11.719s-5.185-11.719-11.63-11.719c-6.445 0-11.63 5.225-11.63 11.72zm104.665-66.113v23.926c17.687 3.613 31.013 19.433 31.013 38.281v20.361c0 3.711-2.617 6.934-6.251 7.666l-15.603 3.125c-2.084.44-4.12-.927-4.555-3.076l-1.502-7.666c-.436-2.1.92-4.2 3.052-4.59l9.353-1.904v-13.916c0-30.664-46.519-31.787-46.519.928v13.037l9.352 1.904c2.084.44 3.44 2.49 3.053 4.59l-1.502 7.666c-.436 2.1-2.471 3.467-4.555 3.076l-15.118-2.05c-3.828-.538-6.687-3.81-6.687-7.764v-21.387c0-18.848 13.325-34.62 31.012-38.281v-22.07c-1.066.341-2.132.537-3.198.927-8.722 3.076-18.074 4.785-27.814 4.785-9.74 0-19.092-1.709-27.814-4.785-3.586-1.27-7.22-2.05-10.951-2.539v39.844c11.193 3.369 19.382 13.72 19.382 26.074 0 15.088-12.162 27.344-27.135 27.344s-27.136-12.256-27.136-27.344c0-12.353 8.19-22.705 19.383-26.074v-39.258C71.5 146.973 48 173.73 48 206.25v21.875C48 240.185 57.74 250 69.708 250h173.668c11.969 0 21.709-9.814 21.709-21.875V206.25c0-35.156-27.524-63.623-62.025-65.332z",
    transform: "translate(-637 -414) translate(552 330) translate(37 84)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDoctorB);
export default __webpack_public_path__ + "static/media/user-doctor-b.1eb63a4862197ae409e257b27a93a8c3.svg";
export { ForwardRef as ReactComponent };